/* eslint-disable */
// ################# New ###################
import React, { useEffect, useState } from 'react';
import { usePopupManager } from '../../../providers/PopupManager/PopupManager';
import { MESSAGE_TYPE } from '../../../constants';
import jwt_decode from "jwt-decode";
import Select from 'react-select';
import axios from 'axios';
import config from '../../../config/config';
import FileLogsTableComp from './DynamicPaginatedTable/FileLogsTableComp';
// import DynamicPaginatedTable from '../DynamicPaginatedTable/DynamicPaginatedTable';
import ReusableTable from '../../ReusableTable/ReusableTable';
import styles from './FileuploadLogsComp.module.css';

const { API_BASE_URL } = config;

const FileuploadLogsComp = () => {

  const UserToken = keycloak.token;
  let username = '';
  let Email = '';

  if (UserToken) {
    const decoded = jwt_decode(UserToken);
    username = decoded.preferred_username;
    Email = decoded.email;
  }

  const { showPopup } = usePopupManager();

  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const [towerOptions, setTowerOptions] = useState([]);
  const [tower, setTower] = useState([]);

  const itemsPerPage = 50;

  const handleTowerChange = (selected) => {
    setTower(selected);
  };

  const fetchTowerOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/tower-list-file-upload-logs`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setTowerOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchData = async (page = 1, applyFilter = false) => {
    const towerFilter = Array.isArray(tower) && tower.length > 0 ? tower.map(e => e.value) : [];
    setIsLoading(true);
    setLoading(true);
    // setPageLoading(false);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/file-upload-logs-table`,
        {
          towerName: towerFilter,
          fromDate: fromDate,
          toDate: toDate,
          pageNumber: page,
          pageSize: itemsPerPage,
          from_date: applyFilter ? fromDate : null,
          to_date: applyFilter ? toDate : null
        },
        {
          headers: {
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          }
        }
      );

      const resData = response.data;
      setData(resData.data || []);
      setTotalRecords(resData.totalCount || 0);

    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
    setLoading(false);
    setIsLoading(false);
    setPageLoading(true);
  };

  useEffect(() => {
    // fetchData(1);
    fetchTowerOptions();
  }, []);

  const handlePageChange = (page) => {
    fetchData(page, true);
  };

  const handleApply = () => {
    if (!fromDate || !toDate) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select both From and To dates.",
      });
      return;
    }

    if (fromDate > toDate) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "From date cannot be greater than To date.",
      });
      return;
    }

    fetchData(1, true);
  };

  const handleReset = () => {
    setFromDate('');
    setToDate('');
    setPageLoading(false);
    setTower([]);
  };

  // const handleCSVDownload = () => {
  //   alert("Download clicked!");
  // };

  const handleCSVDownload = async () => {
    setIsDownloading(true);
    try {
      const towerFilter =
        Array.isArray(tower) && tower.length > 0
          ? tower.map(t => t.value)
          : [];
      const response = await axios.post(
        `${API_BASE_URL}/api/file-upload-logs-csv-download`,
        {
          towerName: towerFilter,
          fromDate: fromDate,
          toDate: toDate
        },
        {
          responseType: "blob",
          headers: {
            Authorization: "Basic YWRtaW4xOjEyMw=="
          }
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file_upload_logs.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("CSV download failed:", error);
    } finally {
      setIsDownloading(false);
    }
  };


  const allColumns = [
    { header: "ID", accessor: "id" },
    { header: "Tower Name", accessor: "tower_name" },
    { header: "Template Name", accessor: "entity_name" },
    { header: "File Name", accessor: "file_name" },
    { header: "Uploader Name", accessor: "uploaded_by" },
    { header: "Created Date", accessor: "created_date" },
    { header: "Approved Name", accessor: "approved_by" },
    { header: "Updated Date", accessor: "updated_date" },
    { header: "Status", accessor: "status" },
    { header: "Comments", accessor: "comments" },
  ];

  const customStylesMultiSelect = {
    control: (provided) => ({
      ...provided,
      minHeight: '40px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '100px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Tower Name:</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                isMulti
                value={tower}
                onChange={handleTowerChange}
                options={towerOptions}
                isSearchable={true}
                placeholder="Select Tower"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Created Date From<span className={styles.required}> *</span> :</label>
            <div className={styles.filter_select_wrapper}>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                max={new Date().toISOString().split("T")[0]} 
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Created Date To<span className={styles.required}> *</span> :</label>
            <div className={styles.filter_select_wrapper}>
              <input
                type="date"
                className="form-control"
                value={toDate}
                max={new Date().toISOString().split("T")[0]} 
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <div className={styles.filter_select_wrapper}>
              <div className="filter-panel-col mt-3">
                <button onClick={handleApply} className="btn apply-btn m-2">
                  Apply
                </button>
                <button onClick={handleReset} className="btn reset-btn">
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {pageLoading ? ( */}
        {/* // <div className={styles.filter_panel_container}>
        //   <div className="spinner-border text-primary mb-3" role="status"></div>
        //   <div style={{ fontSize: "18px", fontWeight: "bold", color: "#0983b1" }}>Please wait..</div>
        // </div>
        <></> */}
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
          </div>
        </div>
      )}
      {pageLoading && (
        <div className={styles.filter_panel_container}>
          <h5>File Uploaded Logs</h5>
          <FileLogsTableComp
            data={data}
            columns={allColumns}
            itemsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
            isCustomOpen={true}
            totalRecords={totalRecords}
            handleCSVDownload={handleCSVDownload}
            dataLoading={loading}
            isDownloading={isDownloading}
          />
        </div>
      )}
    </>
  );
};

export default FileuploadLogsComp;
